module.exports = __webpack_public_path__ + "static/media/img-error-404.f1174b0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Error404/images/img-error-404.png
// module id = 5229
// module chunks = 13